module.exports = __webpack_public_path__ + "static/img/zhong4.aa768bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhong4.png
// module id = +uPs
// module chunks = 16